<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="type"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.type"
          selectType="select"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'MES_JOB_FLAG' }"
          searchParam="lookupValue"
        />
        <global-select
          v-decorator="['organizationCode', { rules: [{ required: true }] }]"
          :allow-clear="false"
          :default-active-first-option="true"
          slot="organizationCode"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.organizationCode"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
        <a-range-picker
          slot="deliveryDate"
          v-model="currentDeliveryDateObj"
          :disabled-date="disabledDate"
          @calendarChange="calendarPriceRangeChange"
          @change="changePriceRangeDate"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" @click="handleExport"
                  v-hasPermi="['inv:invReportPlanDelivery:completedRateListExport']">导出</a-button>
        <download-modal :apiFun="apiPlanCompletedRateListExport" ref="download" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <a-table
          ref="dataTable"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
          :columns="columns"
          :data-source="tableDataSource"
          :pagination="false"
        >
          <template slot="deliveryDate" slot-scope="text, record">
            <a
              @click="toDetails(record)"
              href="javascript:;"
            >{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}
            </a>
          </template>
        </a-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetPlanCompletedRateList, apiPlanCompletedRateListExport } from '@/api/report/plan-delivery-rate'
import { apiLookupDataList } from '@/api/system/lookup/look-up-detail.js'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import moment from 'moment'

export default {
  // eslint-disable-next-line
  name: 'Plan-completion-rate', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      apiPlanCompletedRateListExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetPlanCompletedRateList, true),
        pageCurrent: false
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
				type: undefined,
				organizationCode: undefined,
				deliveryDateFrom: undefined,
				deliveryDateTo: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
				{
					label: '类型',
					decorator: ['type'],
					type: 'type'
				},
        {
          label: '组织',
          decorator: ['organizationCode'],
          type: 'organizationCode'
        },
				{
					label: '起止时间',
					decorator: ["deliveryDate"],
          type: 'deliveryDate'
				}
      ],
      // 表格字段
      columns: [
        {
          title: '数据项目',
          dataIndex: 'dataItems',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '所属车间code',
          dataIndex: 'workCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '所属车间',
          dataIndex: 'workshopDesc',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '目标值',
          dataIndex: 'targetValue',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '整体',
          dataIndex: 'sumProportion',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '维度',
          dataIndex: 'organizationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划完成数',
          dataIndex: 'planQuantity',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '实际达交数',
          dataIndex: 'deliveryQuantity',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '占比',
          dataIndex: 'proportion',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          dataIndex: 'deliveryDate',
          align: 'center',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'deliveryDate' }
        }
      ],
      tableDataSource: [],
      selectedStartDate: '',
      currentDeliveryDateObj: [],
      typeData: [],
      type: undefined
    }
  },
  created () {
    this.queryParams.deliveryDateFrom = moment().subtract(30, 'days').format('YYYY-MM-DD')
    this.queryParams.deliveryDateTo = moment().format('YYYY-MM-DD')
    this.currentDeliveryDateObj = [ moment().subtract(30, 'days'), moment() ]
  },
  mounted () {
    apiLookupDataList({ lookupType: 'MES_JOB_FLAG' }).then((res) => {
      if (res.code === 200) {
        this.typeData = res.rows
      }
    })
    this.onSearch()
  },
  methods: {
    changePriceRangeDate (dateArr, dateStrArr) {
      this.selectPriceDate = "";
      if (dateStrArr.length > 0) {
        this.queryParams.deliveryDateFrom = dateStrArr[0]
        this.queryParams.deliveryDateTo = dateStrArr[1]
      } else {
        this.queryParams.deliveryDateFrom = undefined
        this.queryParams.deliveryDateTo = undefined
      }
    },
    calendarPriceRangeChange (date) {
      this.selectPriceDate = date[0];
    },
    disabledDate (current) {
      if (this.selectPriceDate) {
        const selectV = moment(this.selectPriceDate, "YYYY-MM-DD").valueOf();
          return (
           (current > moment().endOf('day') ||
            current > moment(new Date(selectV + 86400000 * 30), "YYYY-MM-DD")) ||
            current < moment(new Date(selectV - 86400000 * 30), "YYYY-MM-DD")
          );
      } else {
        return current && current > moment().endOf('day');
      }
    },
    // 表单搜索
    onSearch (value = {}) {
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel
      // this.$refs.dataTable.searchParams = params;
      // this.$refs.dataTable.getData();
      apiGetPlanCompletedRateList(params).then((res) => {
        if (res.code === 200) {
          this.tableDataSource = res.data
        }
      })
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
				type: undefined,
				organizationCode: undefined,
				deliveryDateFrom: undefined,
				deliveryDateTo: undefined
      }
      this.currentDeliveryDateObj = []
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 跳转到详情页面
    toDetails (record) {
      this.type = this.typeData.find(item => record.dataItems.indexOf(item.lookupValue) !== -1).lookupCode
      this.$router.push({ path: `/plan-completion-rate/reportDetail/${record.deliveryDate}`, query: { row: JSON.stringify(record), apiType: 'completion', type: this.type } })
    },
    // 导出
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less"></style>
